var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlPillowFilled = function SvgHtlPillowFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.492 12.987a.5.5 0 0 1-.122-.015l-1.878-.469a20.333 20.333 0 0 1-4.4.426A24.006 24.006 0 0 1 3.52 12.5l-1.889.472a.502.502 0 0 1-.596-.645l.448-1.345a11.2 11.2 0 0 1 0-5.984l-.448-1.342a.5.5 0 0 1 .596-.646l1.878.47a20.247 20.247 0 0 1 4.4-.427c1.533-.004 3.063.14 4.57.429l1.888-.472a.5.5 0 0 1 .596.646L14.52 5c.55 1.957.55 4.027 0 5.984l.447 1.343a.5.5 0 0 1-.475.66ZM7.909 6.002c-1.359-.02-2.715.134-4.035.459a.5.5 0 1 0 .275.961 14.8 14.8 0 0 1 3.748-.424 18.52 18.52 0 0 1 4.007.431.5.5 0 1 0 .216-.976A19.448 19.448 0 0 0 7.91 6v.002Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.01 6.942a18.08 18.08 0 0 1 8 0h-8Z"
  })));
};
export default SvgHtlPillowFilled;